import * as tslib_1 from "tslib";
import './select.less';
import classnames from 'classnames';
import m from 'mithril';
import { cleanupOptions } from '../../util/formutils';
import { Component } from '../component';
var Select = /** @class */ (function (_super) {
    tslib_1.__extends(Select, _super);
    function Select() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.className = _this.attrs.className || (_this.attrs.unstyled && 'select') || 'select-front';
        return _this;
    }
    Select.prototype.view = function () {
        var _a = this.attrs, value = _a.value, onchange = _a.onchange, label = _a.label, name = _a.name, options = _a.options, modifier = _a.modifier, onfocus = _a.onfocus, _b = _a.required, required = _b === void 0 ? true : _b;
        var cleanOptions = cleanupOptions(options);
        var fullLabel = required ? label + ' *' : label;
        return m("select." + this.className, {
            class: classnames([modifier, value && 'has-value']),
            name: name,
            required: required,
            onfocus: onfocus,
            onchange: onchange && (function (e) { return onchange(e.target.value); }),
            oninput: onchange && (function (e) { return onchange(e.target.value); })
        }, [
            label && m('option[disabled]', { selected: !value }, fullLabel),
            cleanOptions.map(function (o) {
                return m('option', { value: o.key, selected: o.key == value }, o.label);
            })
        ]);
    };
    return Select;
}(Component));
export { Select };
